import MainLayout from "../layout/MainLayout";
import UsersDefault from "../pages/users";
import User from "../pages/user";
import OnDemand from "../pages/on-demand";
import Reports from "../pages/reports";
import TenancyManagement from "../pages/tenancy";
import SimulationDetails from "../pages/simulations/SimulationDetails";
import ContentPacks from "../pages/content-packs";
import ContentPackDetails from "../pages/content-packs/ContentPackDetails";
import Tenants from "../pages/tenant-table";
import CustomEmailTemplate from "../pages/tenancy/CustomEmailTemplate";
import CustomLandingPage from "../pages/tenancy/CustomLandingPage";
import DeliveryDashboard from "../pages/delivery/index";
import DeliveryRequestForm from "../pages/delivery/DeliveryRequestForm";
import DeliveryRequestDetail from "../pages/delivery/DeliveryRequestDetail";
import PresetDeliveryForm from "../pages/delivery/PresetDeliveryForm";
import DeliveryCalendarPage from "../pages/delivery/DeliveryCalendarPage";



const TenancyAdminRoutes = {
    element: <MainLayout />,
    children: [
        {
            path: 'users',
            element: <UsersDefault />
        },
        {
            path: 'users/:id',
            element: <User />
        },
        {
            path: 'settings',
            element: <TenancyManagement />
        },
        {
            path: 'on-demand',
            element: <OnDemand />
        },
        {
            path: 'packs',
            element: <ContentPacks />
        },
        {
            path: "packs/add",
            element: <ContentPackDetails />
        },
        {
            path: "packs/edit/:id",
            element: <ContentPackDetails />
        },
        {
            path: 'reports',
            element: <Reports />
        },
        {
            path: "simulations/edit/:id",
            element: <SimulationDetails />
        },
        {
            path: "tenants",
            element: <Tenants />
        },
        {
            path: "settings/customemail",
            element: <CustomEmailTemplate />
        },
        {
            path: "settings/customlandingpage",
            element: <CustomLandingPage />
        },
        {
            path: "settings/customlandingpage",
            element: <CustomLandingPage />
        },
        {
            path: "delivery",
            element: <DeliveryDashboard />
        },
        {
            path: "delivery/edit/:tenancyId/:requestId",
            element: <DeliveryRequestForm isEditing={true} />
        },
        {
            path: "delivery/view/:tenancyId/:requestId",
            element: <DeliveryRequestDetail />
        },
        {
            path: "delivery/preset/create",
            element: <PresetDeliveryForm />
        },
        {
            path: "delivery/preset/edit/:presetId",
            element: <PresetDeliveryForm isEditing={true} />
        },
        {
            path: "delivery/calendar/:tenancyId/:deliveryGroupId",
            element: <DeliveryCalendarPage />
        },
        {
            path: "delivery/calendar-create/:tenancyId",
            element: <DeliveryCalendarPage />
        },
        {
            path: "delivery/calendar-preset/:tenancyId",
            element: <DeliveryCalendarPage />
        }
    ]
};

export default TenancyAdminRoutes;
